import { axios } from '@/utils/request'

const api = {
    add: '/5dc7710be1166',
    getList: '/5dc7752e43dd8',
    edit: '/5dc771fe66046',
    delete: '/5dc7730eb3645',
    setDeviceGroup: '/5dc77913b82d8',
    setNickName: '/64376d7ed6f6c',
}

export default {
    // 获取列表
    getList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 200
        })
        return axios({
            url: api.getList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 新增
    add: (parameter) => {
        const params = parameter
        return axios({
            url: api.add,
            method: 'post',
            data: params
        })
    },
    // 编辑
    edit: (parameter) => {
        const params = parameter
        return axios({
            url: api.edit,
            method: 'post',
            data: params
        })
    },
    // 删除
    delete: (parameter) => {
        const params = parameter
        return axios({
            url: api.delete,
            method: 'get',
            params: params
        })
    },
    // 添加设备到分组
    setDeviceGroup: (parameter) => {
        const params = parameter
        return axios({
            url: api.setDeviceGroup,
            method: 'post',
            data: params
        })
    },
    // 修改机器人昵称
    setNickName: (parameter) => {
        const params = parameter
        return axios({
            url: api.setNickName,
            method: 'get',
            params: params
        })
    },
}
